import React from 'react';
import { connect } from 'react-redux';

import FlatButton from 'material-ui/FlatButton';
import Dialog from 'material-ui/Dialog';

import { MODALS } from '../../constants/Constants';
import * as modalActions from '../../actions/ModalActions';
import * as accountGroupsActions from '../../actions/entities/AccountGroupsActions';

const Modal = ({ open, accountGroups: { currentGroupError }, closeModal, createAccountGroup, updateAccountGroup }) => {
  const conflict = currentGroupError && currentGroupError.error && currentGroupError.error.errorCode === 'conflict';
  const handleClose = () => closeModal(MODALS.ACCOUNT_GROUP_SAVE_CONFIRM);
  const actions = [<FlatButton label="Cancel" onClick={handleClose} />];
  if (conflict) {
    actions.push(
      <FlatButton
        primary
        label="Override"
        onClick={() => {
          const data = currentGroupError.originalArgs && currentGroupError.originalArgs[0];
          const newData = { ...data, force: true };
          if (newData.id) {
            updateAccountGroup(newData);
          } else {
            createAccountGroup(newData);
          }
          handleClose();
        }}
      />
    );
  }
  return (
    <Dialog
      actions={actions}
      modal={false}
      open={open}
      onRequestClose={handleClose}
      contentStyle={{ minWidth: '200px', maxWidth: '500px' }}
    >
      {conflict ? (
        <span>A different default account group for given language already exists. Would you like to override it?</span>
      ) : (
        <span>
          Unexpected error occurred:{' '}
          {(currentGroupError && currentGroupError.error && currentGroupError.error.errorMessage) || 'Unknown'}
        </span>
      )}
    </Dialog>
  );
};

const mapStateToProps = ({ modals, entities: { accountGroups } }) => ({
  ...modals[MODALS.ACCOUNT_GROUP_SAVE_CONFIRM],
  accountGroups
});

export default connect(mapStateToProps, { ...modalActions, ...accountGroupsActions })(Modal);



// WEBPACK FOOTER //
// ./src/containers/modals/AccountGroupSaveConfirmModal.js